import tippy from 'tippy.js'

export function nurseTierTooltipOptions(content, body) {
    return {
        appendTo: () => body,
        arrow: false,
        content,
        maxWidth: 'calc(100vw - 2rem)',
        placement: 'auto',
        popperOptions: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        altAxis: true,
                        padding: 12,
                    },
                },
            ],
        },
        theme: 'nurse-tier',
        trigger: 'mouseenter focus',
        zIndex: 9999,
    }
}

if (typeof document !== 'undefined') {
    document.addEventListener('alpine:init', () => {
        window.Alpine.data('nurseTierTooltip', () => ({
            tooltip: null,

            init() {
                const tooltipTemplate = this.$root.querySelector('[data-nurse-tier-tooltip-template]')
                const tooltipContent = tooltipTemplate?.content.firstElementChild?.cloneNode(true)

                if (! tooltipContent) {
                    return
                }

                this.tooltip = tippy(
                    this.$root,
                    nurseTierTooltipOptions(tooltipContent, document.body),
                )
            },

            destroy() {
                this.tooltip?.destroy()
            },
        }))
    })
}
